import { useSecurityContext } from '../../hooks/security-provider.tsx';

const NoAccountBanner = () => {
  const { currentAccount } = useSecurityContext();

  return (
    <>
      {!currentAccount && (
        <div className='flex items-center gap-x-6 bg-red-600 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 rounded-lg mb-5'>
          <p className='text-sm/6 text-white flex items-center'>
            <span>
              <strong className='font-semibold'>Account Not Selected</strong>
              <span className='m-2 w-0.5 h-0.5 rounded-full bg-current inline-block'></span>
              There is currently no account selected - Please select an account from the drop down
              above to continue.&nbsp;
              <span aria-hidden='true'>&uarr;</span>
            </span>
          </p>
          <div className='flex flex-1 justify-end'></div>
        </div>
      )}
    </>
  );
};

export default NoAccountBanner;
